const pushCoverageRolloutWorkplan = 'pushCoverageRolloutWorkplan';
const pushCoverageEditRolloutWorkplan = 'pushCoverageEditRolloutWorkplan';
const pushCoveragePauseWorkplan = 'pushCoveragePauseWorkplan';
const pushCoverageEditPauseWorkplan = 'pushCoverageEditPauseWorkplan';
const pushCoverageStopWorkplan = 'pushCoverageStopWorkplan';
const pushCoverageAddShiftline = 'pushCoverageAddShiftline';
const pushCoveragePauseShiftline = 'pushCoveragePauseShiftline';
const pushCoverageStopShiftline = 'pushCoverageStopShiftline';

export const Coverages = Object.freeze({
    [pushCoverageRolloutWorkplan]: 0,
    [pushCoverageEditRolloutWorkplan]: 1,
    [pushCoveragePauseWorkplan]: 2,
    [pushCoverageEditPauseWorkplan]: 3,
    [pushCoverageStopWorkplan]: 4,
    [pushCoverageAddShiftline]: 5,
    [pushCoveragePauseShiftline]: 6,
    [pushCoverageStopShiftline]: 7,
});

export const CoveragesKeys = Object.freeze({
    0: pushCoverageRolloutWorkplan,
    1: pushCoverageEditRolloutWorkplan,
    2: pushCoveragePauseWorkplan,
    3: pushCoverageEditPauseWorkplan,
    4: pushCoverageStopWorkplan,
    5: pushCoverageAddShiftline,
    6: pushCoveragePauseShiftline,
    7: pushCoverageStopShiftline,
});
